import { render, staticRenderFns } from "./quotation_add.vue?vue&type=template&id=e6764fa6&scoped=true&"
import script from "./quotation_add.vue?vue&type=script&lang=js&"
export * from "./quotation_add.vue?vue&type=script&lang=js&"
import style0 from "./quotation_add.vue?vue&type=style&index=0&id=e6764fa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6764fa6",
  null
  
)

export default component.exports